import React from 'react';

 const DistributionContext:any = React.createContext(null);
export default DistributionContext;

export const DistributionStepContext:any = React.createContext(null);
